module["exports"] = [
  "#{street}"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/sk/address/street_name.js
 ** module id = 945
 ** module chunks = 0
 **/